import Reactotron from 'reactotron-react-js';
import { reactotronRedux } from 'reactotron-redux';
import reactotronSaga from 'reactotron-redux-saga';

// Criar fallback do console.tron antes de tentar inicializar
console.tron = {
  log: () => {},
  warn: () => {},
  error: () => {},
  clear: () => {},
};

if (process.env.NODE_ENV === 'development') {
  // Suprimir erros de WebSocket e findDOMNode antes de inicializar o Reactotron
  if (typeof window !== 'undefined') {
    const originalError = console.error;
    const originalWarn = console.warn;
    
    // Função para verificar se deve suprimir a mensagem
    const shouldSuppress = (message) => {
      if (typeof message !== 'string') {
        // Verificar se é um objeto de erro que contém a mensagem
        if (message && typeof message === 'object' && message.message) {
          return shouldSuppress(message.message);
        }
        return false;
      }
      
      // Ignorar erros de WebSocket do Reactotron (várias variações)
      const websocketPatterns = [
        'WebSocket',
        'connection establishment',
        'ERR_CONNECTION_REFUSED',
        'ws://localhost:9090',
        'ws://',
        'createSocket',
        'reactotron-core-client',
        'ReactrotronConfig',
        'connect @ reactotron',
        'createSocket @ index.ts',
        'net::ERR_CONNECTION_REFUSED',
        'Error in connection establishment'
      ];
      
      if (websocketPatterns.some(pattern => message.includes(pattern))) {
        return true;
      }
      
      // Ignorar warnings de findDOMNode deprecated (de bibliotecas de terceiros)
      if (message.includes('findDOMNode is deprecated')) {
        return true;
      }
      
      return false;
    };
    
    console.error = function(...args) {
      // Verificar todos os argumentos, incluindo objetos de erro
      const shouldSuppressMessage = args.some(arg => {
        if (typeof arg === 'string') {
          return shouldSuppress(arg);
        }
        if (arg && typeof arg === 'object') {
          // Verificar propriedades comuns de objetos de erro
          if (arg.message && shouldSuppress(arg.message)) return true;
          if (arg.stack && shouldSuppress(arg.stack)) return true;
          if (arg.toString && shouldSuppress(arg.toString())) return true;
        }
        return false;
      });
      
      if (shouldSuppressMessage) {
        return; // Não exibe o erro
      }
      
      // Para outros erros, chama o handler original
      originalError.apply(console, args);
    };

    console.warn = function(...args) {
      // Verificar todos os argumentos, não apenas o primeiro
      const shouldSuppressMessage = args.some(arg => 
        typeof arg === 'string' && shouldSuppress(arg)
      );
      
      if (shouldSuppressMessage) {
        return; // Não exibe o warning
      }
      
      // Para outros warnings, chama o handler original
      originalWarn.apply(console, args);
    };

    // Também capturar erros não tratados relacionados ao WebSocket
    window.addEventListener('error', (event) => {
      if (event.message && shouldSuppress(event.message)) {
        event.preventDefault();
        return false;
      }
    }, true);
  }

  // Tentar conectar ao Reactotron, mas não inicializar se não estiver disponível
  // Isso evita erros de WebSocket quando o Reactotron não está rodando
  try {
    const tron = Reactotron.configure({
      host: 'localhost',
      port: 9090,
    })
      .use(reactotronRedux())
      .use(reactotronSaga());
    
    // Tentar conectar, mas não falhar se não conseguir
    // O Reactotron tentará reconectar automaticamente em background
    tron.connect();
    
    // Aguardar um pouco para ver se a conexão é estabelecida
    // Se conseguir conectar, substituir o fallback
    setTimeout(() => {
      try {
        if (tron && tron.clear) {
          tron.clear();
          console.tron = tron;
        }
      } catch (e) {
        // Se não conseguir, manter o fallback
      }
    }, 500);
  } catch (error) {
    // Ignorar erros de inicialização do Reactotron silenciosamente
    // console.tron já está definido como fallback acima
  }
}
